import { Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { CollateralPropertyUsage } from '@core/data-access';

@Injectable()
export class PropertyUsagePresetProvider implements FormlyFieldConfigPresetProvider {
  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'button',
      props: {
        label: 'Usage of the property',
        options: [
          { value: CollateralPropertyUsage.RENTAL_SAVINGS, label: 'Owner Occupied' },
          { value: CollateralPropertyUsage.RENTAL_INCOME, label: 'Investment' },
        ],
      },
    };
  }
}

export function registerPropertyUsagePreset(): ConfigOption {
  return { presets: [{ name: 'propertyUsage', config: new PropertyUsagePresetProvider() }] };
}
